import { useTranslation } from "react-i18next";

import { useTyrePositionName } from "hooks";
import { TYRE_POSITIONS } from "models";
import { isInStorageTyre, isOnCarTyre, isOnTruckTyre } from "modules/AppointmentDetails/utils";
import { getCarSeasonOptions } from "utils/common";

import type { SEASONS } from "models";

export type SeasonOption = {
  value: SEASONS;
  text: string;
};

export const useTyreTitleAndSeasons = (tyrePosition: TYRE_POSITIONS = TYRE_POSITIONS.NotTyre) => {
  const { t } = useTranslation();

  const tyrePositionName = useTyrePositionName(tyrePosition);

  let tyreTitle = "";
  if (isInStorageTyre(tyrePosition)) tyreTitle = t("v8_in_storage", "In Storage");
  else if (isOnCarTyre(tyrePosition)) tyreTitle = t("v8_on_car", "On Car");
  else if (isOnTruckTyre(tyrePosition)) tyreTitle = t("v8_on_truck", "On Truck");

  tyreTitle = `${tyreTitle} - ${tyrePositionName}`;

  return { tyreTitle, seasonOptions: getCarSeasonOptions(t) };
};
